import PropTypes from 'prop-types'
import styled from 'styled-components'
import { components } from 'react-select'

import { InnerComponent } from 'components/utils/innerReactSelectComponents'

// TODO: color for active and disabled component is set by react-select. Use our color constants
const SingleValueWrapper = styled(InnerComponent).attrs({ Component: components.SingleValue })`
  && {
    margin: 0;
    height: 16px;
  }
`

const SingleValueWithIcon = styled.div`
  display: flex;
  align-items: center;
  line-height: 16px;
  gap: 4px;
}`

const SingleValue = props => {
  const { iconComponentsMap } = props.selectProps

  if (!iconComponentsMap) {
    return <SingleValueWrapper {...props} />
  }

  const value = props.data.value
  const OptionComponent = () => iconComponentsMap[value]

  return (
    <SingleValueWrapper {...props}>
      <SingleValueWithIcon>
        <OptionComponent />
        {props.data.label}
      </SingleValueWithIcon>
    </SingleValueWrapper>
  )
}

SingleValue.propTypes = {
  selectProps: PropTypes.object,
  data: PropTypes.object,
}

export default SingleValue
